import _get from 'lodash/get';
import { imageService } from '@bedrock/fido-sdk';
import { DEFAULT_IMAGE_FORMAT, IMAGE_FIT_SCALE_CROP, RENDERING_CONTEXT, IMAGE_QUALITY } from '@bedrock-rdk/constants';
import { templates, imageOptions } from '../../tornado/poster/poster.constants';

export const getVideoItemWithProgress = (content, progress = 0) =>
  content
    ? {
        ...content,
        progress,
      }
    : null;

export const makeVideoItem = (content, screenSize) => {
  if (!content) {
    return null;
  }

  const image = _get(content, 'image', {});
  const imageSize = _get(imageOptions, [templates.PosterL, RENDERING_CONTEXT.GENERAL, screenSize, 'PRIMARY'], {});

  return {
    content: {
      ...content,
      image: {
        ...image,
        src: imageService.getUrl(image.id, imageSize.width, imageSize.height, {
          fit: IMAGE_FIT_SCALE_CROP,
          quality: IMAGE_QUALITY,
          format: DEFAULT_IMAGE_FORMAT,
        }),
      },
    },
    template: templates.PosterL,
  };
};
